import React from 'react'

const Authfooter = () => {
  return (
    <div className='footer-auth'>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-lg-12'>
                <div className='d-flex  flex-md-row flex-column align-items-center bottom-ft px-3 justify-content-between'>
                            <div className='mb-lg-0 mb-3 d-flex justify-content-md-start justify-content-center'>
                                <a href=''>Terms of Services</a>
                                <a href=''>Privacy Policy</a>
                            </div>
                            <div className='mb-lg-0 mb-3 d-flex justify-content-md-end justify-content-center'>
                                <p>&copy; 2023 SkyyTask. All rights reserved.</p>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Authfooter